interface Logo {
  id: string;
  description: string;
  image: string;
  className?: string;
}

interface Logos3Props {
  heading?: string;
  logos?: Logo[];
  className?: string;
}

const Logos3 = ({
  heading = "Trusted by these companies",
  logos = [],
}: Logos3Props) => {
  return (
    <section className="py-12 md:py-16 bg-muted/50">
      <div className="container flex flex-col items-center text-center">
        <h2 className="my-6 text-pretty text-2xl font-bold lg:text-4xl">
          {heading}
        </h2>
        <div className="pt-10 flex items-center justify-center gap-12 md:gap-16 flex-wrap">
          {logos.map((logo) => (
            <div key={logo.id} className="flex items-center justify-center h-20">
              <img
                src={logo.image}
                alt={logo.description}
                className={logo.className}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { Logos3 };
